import Button from 'epn-ui/umd/dist/components/Button';
import { TableProps } from 'epn-ui/umd/dist/components/Table';

import isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';

import BaseTableMobileItem from './BaseTableMobileItem';
import BaseError from '../BaseError';

const LOADING_STUBS = 2;

const BaseTableMobile: React.FC<TableProps> = ({
    id,
    className = '',
    data = [],
    columns = [],
    loadMoreParams,
    emptyParams = {},
    errorParams = {},
    isLoading = false,
}) => {
    const { hasNextPage, buttonText = 'Load more', onLoadMoreRows } = loadMoreParams || {};
    const {
        href: emptyLink,
        onClick: onEmptyClick,
        message: emptyMessage = 'No data',
        buttonText: emptyButtonText = '',
    } = emptyParams || {};

    const { requestId = '', message: errorMessage = '' } = errorParams || {};

    if (requestId && !isLoading) {
        return (
            <BaseError
                id={`${id}ErrorMessage`}
                className={clsx(
                    className,
                    'bg-blueGray-100 rounded-2 flex flex-col items-center justify-center py-12',
                )}
                error={{ requestId }}
                message={errorMessage}
            />
        );
    }

    return (
        <div className={className}>
            {isEmpty(data) && !isLoading && (
                <div
                    id={`${id}EmptyMessage`}
                    className="flex flex-col items-center justify-center py-12 text-center px-2.5 bg-blueGray-100 rounded-2"
                >
                    {emptyMessage}
                    <Button
                        id={`${id}EmptyButton`}
                        className="mt-6"
                        type="primary"
                        to={emptyLink}
                        onClick={onEmptyClick}
                        size="medium"
                    >
                        {emptyButtonText}
                    </Button>
                </div>
            )}

            {!isEmpty(data) &&
                data.map((rowData, index) => (
                    <BaseTableMobileItem
                        className="odd:bg-blueGray-100"
                        key={rowData?.id || index}
                        data={rowData}
                        columns={columns}
                    />
                ))}

            {isLoading && (
                <div className={className}>
                    {[...new Array(LOADING_STUBS)].map((_, index) => (
                        <BaseTableMobileItem
                            className="odd:bg-blueGray-100"
                            key={index}
                            data={{ id: index }}
                            columns={columns}
                            isLoading={isLoading}
                        />
                    ))}
                </div>
            )}

            {loadMoreParams && hasNextPage && !isEmpty(data) && (
                <Button
                    id={`${id}LoadMoreButton`}
                    className="mt-6"
                    size="medium"
                    responsive="xl"
                    type="ghost"
                    onClick={onLoadMoreRows}
                    loading={isLoading}
                >
                    {buttonText}
                </Button>
            )}
        </div>
    );
};

export default BaseTableMobile;
